export default "__VITE_ASSET__8c226bab__"